import React from 'react';
import { useCompany } from '@/context/CompanyContext';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Building2, Crown, Users } from 'lucide-react';

export const CompanySelector: React.FC = () => {
  const { currentCompany, companies, userRole, switchCompany } = useCompany();

  if (!currentCompany || companies.length <= 1) {
    return null;
  }

  const handleCompanyChange = async (companyId: string) => {
    if (companyId !== currentCompany.id) {
      await switchCompany(companyId);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Building2 className="w-4 h-4 text-muted-foreground" />
      <Select value={currentCompany.id} onValueChange={handleCompanyChange}>
        <SelectTrigger className="w-[200px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {companies.map((company) => (
            <SelectItem key={company.id} value={company.id}>
              <div className="flex items-center gap-2">
                <span>{company.name}</span>
                {userRole === 'admin' && (
                  <Crown className="w-3 h-3 text-primary" />
                )}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Badge variant={userRole === 'admin' ? 'default' : 'secondary'}>
        {userRole === 'admin' ? 'Admin' : 'Membre'}
      </Badge>
    </div>
  );
};